import JSEncrypt from "jsencrypt";

// 后端提供的公钥 (注意：通常包含 -----BEGIN PUBLIC KEY----- 等字样)

export default {
  // 加密方法
  encrypt(text) {
    const encryptor = new JSEncrypt();
    let str = localStorage.getItem("rsaPublicKey");
    const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
		${str}
		-----END PUBLIC KEY-----`;
    encryptor.setPublicKey(PUBLIC_KEY);
    const result = encryptor.encrypt(text);

    if (!result) {
      console.error("RSA 加密失败，请检查公钥格式");
      return null;
    }
    return result;
  },
};
